<template>
   <div class="vertical-layout" :class="currentLayoutClass">
      <!-- Start Infobar Setting Sidebar -->
    
    <div class="infobar-settings-sidebar-overlay"></div>
    <!-- End Infobar Setting Sidebar -->
     <!-- Start Containerbar -->
    <div id="containerbar">
        <!-- Start Leftbar -->
        <div class="leftbar">
            <!-- Start Sidebar -->
            <div class="sidebar">
                <!-- Start Logobar -->
                <div class="logobar">
                    <a href="/" class="logo logo-large"><img :src="mainLogo" class="img-fluid" alt="logo"></a>
                    <a href="/" class="logo logo-small"><img :src="smallLogo" class="img-fluid" alt="logo"></a>
                </div>
                <!-- End Logobar -->
                <!-- Start Navigationbar -->
                <div class="navigationbar">
                    <ul class="vertical-menu">
                        <li>
                           <router-link :to="{name: 'cliente-anuncios'}">
                              <svg-icon icon="apps" /><span>Anuncios</span><span v-if="getAdvertisementsCount > 0" class="badge badge-success pull-right">{{getAdvertisementsCount}} nuevos</span>
                           </router-link>
                        </li>
                       <!--  <li>
                           <router-link :to="{name: 'cliente-promociones'}">
                              <svg-icon icon="icons" /><span>Promociones</span><span v-if="getPromosCount > 0" class="badge badge-primary pull-right">{{getPromosCount}} nuevas</span>
                           </router-link>
                        </li>  -->
                        <li v-if="!currentUserIsSpecialCustomer">
                           <router-link :to="{name: 'cliente-comprar-promociones'}">
                              <svg-icon icon="icons" /><span>Comprar Promociones</span>
                           </router-link>
                        </li>
                        <li>
                           <router-link :to="{name: 'cliente-comprar'}">
                              <svg-icon icon="ecommerce" /><span>Productos</span>
                           </router-link>
                        </li>
                         <li>
                           <router-link :to="{name: 'cart'}">
                              <svg-icon icon="ecommerce" /><span>Carrito de compras</span>
                           </router-link>
                        </li>
                        <li>
                           <router-link :to="{name: 'cliente-pedidos'}">
                              <svg-icon icon="basic" /><span>Mis pedidos</span>
                           </router-link>
                        </li>
                        <li>
                           <router-link :to="{name: 'cliente-perfil'}">
                              <svg-icon icon="user" /><span>Mi perfil</span>
                           </router-link>
                        </li>
                    </ul>
                </div>
                <!-- End Navigationbar -->
            </div>
            <!-- End Sidebar -->
        </div>
        <!-- End Leftbar -->
        <!-- Start Rightbar -->
        <div class="rightbar">
            <!-- Start Topbar Mobile -->
            <div class="topbar-mobile">
                <div class="row align-items-center">
                    <div class="col-md-12">
                        <div class="mobile-logobar">
                            <a href="/" class="mobile-logo"><img :src="mobileLogo" class="img-fluid" alt="logo"></a>
                        </div>
                        <div class="mobile-togglebar">
                            <ul class="list-inline mb-0">
                                <li class="list-inline-item">
                                    <div class="topbar-toggle-icon">
                                        <a class="topbar-toggle-hamburger" href="#" @click="toggleTopBar" role="button">
                                            <img :src="require('@assets/images/svg-icon/horizontal.svg')" class="img-fluid menu-hamburger-horizontal" alt="horizontal" :style="{display: (showTopBar) ? 'none' : 'inline'}">
                                            <img :src="require('@assets/images/svg-icon/verticle.svg')" class="img-fluid menu-hamburger-vertical" alt="verticle" :style="{display: (showTopBar) ? 'inline' : 'none'}">
                                         </a>
                                     </div>
                                </li>
                                <li class="list-inline-item">
                                    <div class="menubar">
                                        <a class="menu-hamburger" href="#" @click="toggleMobileMenu" role="button">
                                            <img :src="require('@assets/images/svg-icon/collapse.svg')" class="img-fluid menu-hamburger-collapse" alt="collapse" :style="{display: (showMobileMenu) ? 'none' : 'inline'}">
                                            <img :src="require('@assets/images/svg-icon/close.svg')" class="img-fluid menu-hamburger-close" alt="close" :style="{display: (showMobileMenu) ? 'inline' : 'none'}">
                                         </a>
                                     </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Start Topbar -->
            <div class="topbar">
                <!-- Start row -->
                <div class="row align-items-center">
                    <!-- Start col -->
                    <div class="col-md-12 align-self-center">
                       <div class="togglebar">
                            <ul class="list-inline mb-0">
                                <li class="list-inline-item">
                                    <div class="user-credentials">
                                       <p class="m-b-0">
                                          <span class="font-18">{{currentUserName}} <br></span>
                                          No. cliente {{currentUserId}}
                                       </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="infobar">
                            <ul class="list-inline mb-0">
                                <li class="list-inline-item">
                                    <div class="profilebar">
                                        <div class="dropdown">
                                          <a class="dropdown-toggle" href="#" role="button" id="profilelink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img :src="require('@assets/images/users/profile.svg')" class="img-fluid" alt="profile"><span class="feather icon-chevron-down live-icon"></span></a>
                                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="profilelink">
                                                <div class="dropdown-item">
                                                    <div class="profilename">
                                                      <h5>No. {{currentUserId}}</h5>
                                                    </div>
                                                </div>
                                                <div class="userbox">
                                                    <ul class="list-unstyled mb-0">
                                                        <li class="media dropdown-item">
                                                            <div @click="logout" class="profile-icon cursor-pointer"><img :src="require('@assets/images/svg-icon/logout.svg')" class="img-fluid" alt="logout">Cerrar sesión</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- End col -->
                </div> 
                <!-- End row -->
            </div>
            <!-- End Topbar -->
            <!-- Start Breadcrumbbar -->
            <!--div class="breadcrumbbar">
                <div class="row align-items-center">
                    <div class="col-md-8 col-lg-8">
                        <h4 class="page-title">Starter</h4>
                        <div class="breadcrumb-list">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                                <li class="breadcrumb-item"><a href="#">Pages</a></li>
                                <li class="breadcrumb-item"><a href="#">Basic</a></li>
                                <li class="breadcrumb-item active" aria-current="page">Starter</li>
                            </ol>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4">
                        <div class="widgetbar">
                            <button class="btn btn-primary-rgba"><i class="feather icon-plus mr-2"></i>Actions</button>
                        </div>
                    </div>
                </div>
            </div-->
            <!-- End Breadcrumbbar -->
            <!-- Start Contentbar -->
            <div class="contentbar custom-content-view">
               <router-view />
            </div>
            <!-- End Contentbar -->
            <!-- Start Footerbar -->
            <div class="footerbar">
                <footer class="footer">
                    <p class="mb-0">© 2026 Grupo Brime - Todos los derechos reservados.</p>
                </footer>
            </div>
            <!-- End Footerbar -->
        </div>
        <!-- End Rightbar -->
    </div>
    <!-- End Containerbar -->
   </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
export default {
   data(){
      return {
         mainLogo: require('@assets/images/logos/mid-logo.png'),
         smallLogo: require('@assets/images/logos/mid-logo.png'),
         mobileLogo: require('@assets/images/logos/mid-logo.png'),
         showTopBar: false,
         showMobileMenu: false,
      }
  },
   computed: {
      ...mapState("auth", ["user", "special_customer"]),
      ...mapGetters("general", ["getPromosCount", "getAdvertisementsCount"]),
      currentUserName(){
        if(this.user){
            return this.user.Nombre_negocio;
        }
      },
      currentUserId(){
        if(this.user){
            return this.user.Cliente;
        }
      },
      currentUserIsSpecialCustomer(){
          return this.special_customer === true
      },
      currentLayoutClass() {
        const c1 = (this.showTopBar) ? "topbar-toggle-menu " : ""
        const c2 = (this.showMobileMenu) ? "toggle-menu" : ""
        return `${c1}${c2}`
      }
   },
   methods: {
      ...mapMutations("auth", ["cleanSession"]),
      ...mapMutations("cart", ["cleanCart"]),
      async toggleTopBar(){
        this.showTopBar = !this.showTopBar
      },
      async toggleMobileMenu(){
        this.showMobileMenu = !this.showMobileMenu
      },
      async logout(){
        this.cleanCart();
        this.cleanSession();
        await this.$router.replace({name: 'login'});
      }
   }
}
</script>